/**
 * Application store using Zustand
 * Manages product/experiment selection and UI state
 */

import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { Product, ExperimentVersion } from '../types';

interface AppState {
  // Product/Experiment context
  selectedProduct: Product;
  selectedExperiment: ExperimentVersion;

  // Actions
  setProduct: (product: Product) => void;
  setExperiment: (experiment: ExperimentVersion) => void;
}

export const useAppStore = create<AppState>()(
  persist(
    (set) => ({
      // Default values
      selectedProduct: Product.IM_MATH,
      selectedExperiment: ExperimentVersion.V0_0_0,

      setProduct: (product) => set({ selectedProduct: product }),
      setExperiment: (experiment) => set({ selectedExperiment: experiment }),
    }),
    {
      name: 'app-storage',
    }
  )
);
